// extracted by mini-css-extract-plugin
module.exports = {"detailRateButton":"hJ","fadeIn":"hK","fadeOut":"hL","userRatingIcon":"hM","detailRateButtonLabel":"hN","isRental":"hO"};